export default "__VITE_ASSET__b64164b3__"